import Collapsible from "react-collapsible";
import { useState } from "react";
import { FiPlusCircle, FiMinusCircle } from "react-icons/fi";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const MoreInformation = () => {
  const initialDataState = Object.values(CONSTANTS.moreInformationData).reduce(
    (object, title) => ({
      ...object,
      [title.title]: { open: false },
    }),
    {}
  );
  const [fieldState, setFieldState] = useState(initialDataState);
  const setOpenState = (title, state) => {
    fieldState[title].open = state;
    setFieldState({ ...fieldState });
  };

  return (
    <div className="more-info">
      <div className="heading">Want more information?</div>
      {CONSTANTS.moreInformationData.map((value, index) => (
        <div className="collapsible-field">
          <Collapsible
            trigger={
              <div className="collapsible-title">
                <div className="question">{value.title}</div>

                <div className="open-sign">
                  {fieldState[value.title].open ? (
                    <FiMinusCircle style={CONSTANTS.BIG_ICON} />
                  ) : (
                    <FiPlusCircle style={CONSTANTS.BIG_ICON} />
                  )}
                </div>
              </div>
            }
            transitionTime={200}
            onOpening={() => setOpenState(value.title, true)}
            onClosing={() => setOpenState(value.title, false)}
            key={index}
          >
            <div className="description"> {value.Description}</div>
          </Collapsible>
          <div className="small-line" />
        </div>
      ))}
    </div>
  );
};

export default MoreInformation;
